










































import Vue from 'vue';
import { default as ColourPicker } from '@/shared/services/color';
import { Component, Prop} from 'vue-property-decorator';

@Component
export default class HomeScreenPanelStartChat extends Vue {
	@Prop() public brandColour: string;
	@Prop() public actionColour: string;

	public title: string = 'Need help?';
	@Prop() public subtitle: string;
	public latestMessage: null = null;

	get textColour() {
		return ColourPicker.getContrastingColour(this.actionColour);
	}

	public getDarkPrimary() {
		return ColourPicker.darken(this.brandColour, 12);
	}
}
